exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cards{box-shadow:1px 5px 7px 5px rgba(0,0,0,.1);border-left-width:px;padding:30px 50px 30px 55px;border-bottom-width:30px;border-color:15px gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1321a7b8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/resultado.vue
// module id = 472
// module chunks = 0